import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  DYNAMIC_PRICING_PREVIEW_ATTRIBUTION_MAP,
  DynamicPricingSuggestion,
} from '@app/shared/interfaces/lib/dynamic-pricing.interface';
import { CommonModule } from '@angular/common';
import { UiModule } from '@app/ui';
import { HumanizePipe } from '@app/shared/pipes/humanize/humanize.pipe';
@Component({
  standalone: true,
  selector: 'sbnb-dynamic-price-daily-breakdown',
  templateUrl: './dynamic-price-daily-breakdown.component.html',
  styles: `
    @import 'variables';
    .popover {
      background: #fff;
      padding: 8px;
      color: $night;
      border-radius: 16px;
      margin-top: 12px;
      border: 1px solid $smoke;
      max-width: 350px;
      @apply shadow;

      p {
        margin-top: 0 !important;
        padding-top: 0 !important;
        line-height: normal !important;
      }

      &.sidebar-embedded {
        margin-top: 0;
        margin-left: 12px;
      }
    }
    .sidebar-embedded {
      .breakdown {
          @apply p-0 w-auto gap-3;

        &__header {
          @apply text-sm;
        }

        &__body {
           @apply gap-1;
        }

        &__body__base-rate {
           @apply p-0 text-sm;
        }

        &__body__attribution-row {
          @apply p-0 text-sm;
        }

        &__body__dynamic-price {
          @apply text-sm py-1;
        }
      }

      p {
        @apply text-sm; 
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, UiModule, HumanizePipe],
})
export class DynamicPriceDailyBreakdownComponent {
  @Input() customCurrentPriceLabel: string;
  @Input() sidebarEmbedded: boolean = false;
  @Input() preview: DynamicPricingSuggestion;
  @Input() currentPrice: {
    amount: number;
    currency: string;
  };
  public Math = Math;
  public DynamicPricingPreviewAttributionMap = DYNAMIC_PRICING_PREVIEW_ATTRIBUTION_MAP;
}
